module.exports = __webpack_public_path__ + "img/origin-qr-background.96f00201.png";